import { Navigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";
import { Button, EmptyState } from "@/components/ui";
import { adminHandshakeDestinationPath } from "@/components/handshake";
import { LoadingState } from "@/components/common";
import { useGoBack } from "@/hooks/useGoBack";
import { useAdminHandshakeSessionPanel } from "@/hooks/useAdminHandshakeSessionPanel";

/**
 * Resolves `/admin/handshake/:sessionId` to the booking detail page.
 * Every handshake session is created with a booking_id.
 */
export default function HandshakeAuditPage() {
  const { t } = useTranslation("handshakePages");
  const { sessionId } = useParams<{ sessionId: string }>();
  const goBack = useGoBack("/admin/handshake");

  const { data: session, isLoading, isError } = useAdminHandshakeSessionPanel(
    sessionId ?? "",
  );

  if (isLoading) {
    return (
      <div className="flex h-[calc(100vh-8rem)] items-center justify-center">
        <LoadingState message={t("loadingAudit")} />
      </div>
    );
  }

  if (isError || !session) {
    return (
      <EmptyState
        icon={AlertCircle}
        title={t("conversationNotFound")}
        action={
          <Button variant="outline" onClick={goBack}>
            {t("backToDashboard")}
          </Button>
        }
        className="h-[calc(100vh-8rem)]"
      />
    );
  }

  return (
    <Navigate
      to={adminHandshakeDestinationPath(session)}
      replace
    />
  );
}
